import { render, staticRenderFns } from "./BrandPickup.vue?vue&type=template&id=71130fff&"
import script from "./BrandPickup.vue?vue&type=script&lang=js&"
export * from "./BrandPickup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports